export interface FAQItem {
  id: string
  question: string
  answer: string | string[]
}

const createFaqItem = (id: string, question: string, answer: string | string[]): FAQItem => ({
  id,
  question,
  answer,
})

const REFINANCING_REQUEST_STEPS = [
  'Você solicita, analisamos e aprovamos sua proposta',
  'Registramos o contrato no sistema oficial do governo',
  'Sua empresa recebe a informação para descontar o novo valor',
  'O empréstimo antigo é quitado e o novo começa',
]

const formatNumberedSteps = (steps: string[]) =>
  steps.map((step, index) => `${index + 1}) ${step}`).join('\n\n')

export const faqData: FAQItem[] = [
  createFaqItem(
    '1',
    'Como funciona o refinanciamento de consignado?',
    'No refinanciamento, quitamos seu empréstimo atual e você contrata um novo com melhores condições. Você pode conseguir parcelas menores, prazos maiores e até receber um valor extra na conta.',
  ),
  createFaqItem(
    '2',
    'Em quanto tempo o dinheiro cai na conta após a contratação?',
    'Pelo app ou site, pode ser em até 1 hora. Pela CTPS, após aprovação e envio da documentação completa, depois de aprovado o dinheiro é liberado em até 1 dia útil na sua conta Inter.',
  ),
  createFaqItem(
    '3',
    'Refinanciamento e portabilidade',
    'Após aprovação, o processo leva de 5 a 15 dias úteis para conclusão, dependendo da atualização nos sistemas da empresa e DataPrev.',
  ),
  createFaqItem(
    '4',
    'Quem pode refinanciar ou fazer portabilidade',
    'Quem possui empréstimo consignado ativo com no mínimo 3 parcelas já pagas e margem disponível para novas operações.',
  ),
  createFaqItem(
    '5',
    'O que acontece depois que eu solicito o refinanciamento',
    formatNumberedSteps(REFINANCING_REQUEST_STEPS),
  ),
  createFaqItem(
    '6',
    'O que é a escrituração do contrato?',
    'A escrituração é o registro oficial do contrato no sistema do Crédito do Trabalhador. Esse registro confirma a operação entre as instituições financeiras e permite que o refinanciamento avance para a etapa de averbação na folha de pagamento.',
  ),
  createFaqItem(
    '7',
    'O que significa averbação?',
    'A averbação é o momento em que o contrato é registrado na sua folha de pagamento, permitindo que as parcelas do empréstimo sejam descontadas diretamente do seu salário.',
  ),
  createFaqItem(
    '8',
    'Quando as novas parcelas começam a ser descontadas?',
    'As parcelas começam depois que seu empregador fecha a folha de pagamento. Se a averbação for feita antes desse fechamento, o desconto já entra na próxima folha.',
  ),
]
